import { IconButton, makeStyles, TableCell, TableRow, Tooltip } from "@material-ui/core";
import { Assignment } from "@material-ui/icons";
import { useState } from "react";
import { Link } from "react-router-dom";
import Signifier from "../Signifier";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  itemIcon: {
    transform: "scale(1.5)",
  },
}));

export default function OutboundFeedTableCell({ columns, element, index }) {
  const classes = useStyles();
  const [showSignifier, setShowSignifier] = useState(false);

  const copyLink = (e, id) => {
    e.preventDefault();
    navigator.clipboard.writeText(`${import.meta.env.VITE_JOB_FEEDS}/api/feeds/${id}`);
    setShowSignifier(true);
  };

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message="Link Copied to Clipboard"
        error={false}
      />
      <TableRow
        hover
        className={index % 2 ? classes.rowCell : classes.rowCellOdd}
        key={index}
        component={Link}
        to={{ pathname: "/outboundfeeds/outboundfeeddetailed", state: element }}
      >
        {columns.map((column, elementIndex) => (
          <TableCell align="left" key={elementIndex}>
            {column.label !== "Link" ? (
              element[column.propName]
            ) : (
              <Tooltip title="Copy API URL">
                <IconButton
                  onClick={(e) => copyLink(e, element[column.propName])}
                  className={classes.itemIcon}
                >
                  <Assignment />
                </IconButton>
              </Tooltip>
            )}
          </TableCell>
        ))}
      </TableRow>
    </>
  );
}
